import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div id="notfound">
      <Helmet>
        <title>404 Page Not Found</title>
      </Helmet>
      <div className="notfound">
        <div className="notfound-404">
          <h1>404</h1>
        </div>
        <h2>Access via QR Code Only!</h2>
        <p>
          This website is only accessible by scanning the official QR code.
          Direct URL access is not supported. Please scan the QR code to
          continue.
        </p>
        {/* <button
          onClick={() => {
            navigate(-1);
          }}
        >
          Back To Homepage
        </button> */}
      </div>
    </div>
  );
}
